module.exports = __webpack_public_path__ + "img/trainersignup-04.1a8e2e44.png";